import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { number } from "yup/lib/locale";
import agent from "../api/agent";
import { Carga, Information } from "../models/Carga";
import {  Profile } from "../models/profile";
import { createPermisostoRol, listPermisos, listPermisosByRole, listRoles } from "../models/Roles";
import { store } from "./store";

export default class RolesStore {
    RolesRegistry = new Map<any, listRoles>();
    PermisosRegistry = new Map<any, listPermisos>();

    carga: Carga | null = null;
    nformation: Information | null = null;
    profile: Profile | null = null;
    loadingProfile = false;
    loadingInitial = false;
    uploading = false;
    loading= false;
    selectedFile='';
    mensajes=''; 
    ocultar='' 
    id = ""
    idPermisosActivos: string[] = []
    
    Respuesta = new Map<any, Information>();

    constructor() {
        makeAutoObservable(this);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createRoles = async (nombre: string) => {
        this.loadingInitial = true
        try {
           this.id = await agent.Roles.create(nombre);
           this.setLoadingInitial(false);
           this.loading = false;
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    } 

    AllPermissions = async () =>{
        try{
            const permisos = await agent.Roles.listPermisos();
            permisos.forEach(element => {
                this.setPermisos(element)
            })
            this.setLoadingInitial(false);
            this.loading = false;
        }catch(error){
            runInAction(() => {
                this.setLoadingInitial(false);
                this.loading = false;
            })
        }
    }

    private setPermisos = (data: listPermisos) => {  
        this.PermisosRegistry.set(data.id, data);
    }

    get PermisoByCodigo() {
        return Array.from(this.PermisosRegistry.values());
    }

    assingRolToUser = async (idRol:any, idUser:string, entidad: string) => {
        try{
            //console.log("ROl",idRol)
            const asignar = await agent.Roles.asignarRolaUsuario(idRol, idUser, entidad)
            this.setLoadingInitial(false);
            this.loading = false;
        }catch(error){
            runInAction(() => {
                this.setLoadingInitial(false);
                this.loading = false;
            })
        }
    }

    allRoles = async () =>{
        try{
            const roles = await agent.Roles.listRoles();
            roles.forEach(element => {
                this.setRole(element);
            })
            this.setLoadingInitial(false);
            this.loading = false;
        }catch(error){
            runInAction(() => {
                this.setLoadingInitial(false);
                this.loading = false;
            })
        }
    }

    private setRole = (data: listRoles) => {  
        this.RolesRegistry.set(data.id, data);
    }

    get RolByCodigo() {
        return Array.from(this.RolesRegistry.values());
    }

    assinPermissionsToRol = async (listOfPermisos:createPermisostoRol) => {
        try{
            const asignar = await agent.Roles.createPermisosToRoles(listOfPermisos)
            this.setLoadingInitial(false);
           this.loading = false;
        }catch(error){
            runInAction(() => {
                this.setLoadingInitial(false);
           this.loading = false;
            })
        }
    }

    editRoles = async (id:any, nombre:string) => {
        try{
            await agent.Roles.edit(id, nombre)
            this.setLoadingInitial(false);
           this.loading = false;
        }catch(error){
            this.setLoadingInitial(false);
           this.loading = false;
        }
    }

    getPermisosOfRole = async (id:any) => {
        try{
            this.idPermisosActivos = []
            const permisos = await agent.Roles.editpermisos(id)
            permisos.forEach(element => {
                if(element.is_active){
                    this.idPermisosActivos.push(element.name)
                }
            })
            this.setLoadingInitial(false);
           this.loading = false;
        }catch(error){
            this.setLoadingInitial(false);
           this.loading = false;
        }
    }
}